import { render, staticRenderFns } from "./PCol.vue?vue&type=template&id=27f73446&scoped=true"
import script from "./PCol.vue?vue&type=script&lang=ts"
export * from "./PCol.vue?vue&type=script&lang=ts"
import style0 from "./PCol.vue?vue&type=style&index=0&id=27f73446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f73446",
  null
  
)

export default component.exports